import React from 'react'
import Xerrors from './Xerrors.js'
import Xerrors2 from './Xerrors2.js'

export default function Errors(props) {
  const x_errors = props.x_errors || []
  const x_errors_2 = props.x_errors_2 || []
  const title = props.title
  return (
    <div className="dax-more">
      <h2 className="sr-only">Additional API information</h2>
      {/* x-errors start */}
      <Xerrors x_errors={x_errors} title={title} />
      {/* x-errors end */}
      {/* x-errors-2 start */}
      <Xerrors2 x_errors_2={x_errors_2} title={title} />
      {/* x-errors-2 end */}
    </div>
  )
}
